import { axiosBaseQuery } from 'react-common'
import { request } from 'react-common'
import { createApi } from '@reduxjs/toolkit/query/react'
import { CertificateRecord, CertificateRecordQuery } from '@/api/models/certificate-record'

const ENDPOINT = 'certificate-records'

export const certificateRecordApi = createApi({
  reducerPath: 'certificateRecordApi',
  baseQuery: axiosBaseQuery(request),
  tagTypes: ['CertificateRecord'],
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  endpoints: (builder) => ({
    getCertificateRecordByCertificateNumber: builder.query<CertificateRecord, string>({
      query: (certificateNumber) => ({
        url: `${ENDPOINT}/query`,
        method: 'get',
        params: {
          query: {
            filter: `[["certificateNumber", "=", "${certificateNumber}"]]`,
          },
        },
      }),
      providesTags: (result, error, id) => [{ type: 'CertificateRecord', id }],
      transformResponse: (response: CertificateRecordQuery) => {
        return response?.data?.[0]
      },
    }),
    getPublicCertificateRecordById: builder.query<CertificateRecord, string>({
      query: (id) => ({ url: `public/${ENDPOINT}/${id}`, method: 'get' }),
      providesTags: (result, error, id) => [{ type: 'CertificateRecord', id }],
    }),
    queryCertificateRecords: builder.query<CertificateRecordQuery, Record<string, any>>({
      query: (loadOptions) => ({ url: `${ENDPOINT}/query`, method: 'get', params: { query: loadOptions } }),
      providesTags: (result) =>
        result
          ? ['CertificateRecord', ...result.data.map(({ id }) => ({ type: 'CertificateRecord' as const, id }))]
          : ['CertificateRecord'],
    }),
  }),
})

export const {
  useGetPublicCertificateRecordByIdQuery,
  useQueryCertificateRecordsQuery,
  useGetCertificateRecordByCertificateNumberQuery,
} = certificateRecordApi
